// return timestamp in readable format

export function getTime(timestamp?: number): string {
  if (!timestamp) return "";
  const date = new Date(timestamp);
  const time = date.getTime();
  const now = Date.now();

  const timeString = date.toTimeString().replace(/^(\d+:\d+):.*/, "$1");
  const dateString = date.toDateString();
  const currentDate = new Date(now).toDateString();

  if (currentDate === dateString) {
    return timeString;
  }
  const [day, month, num] = dateString.split(" ");
  if (time - now < 7 * 24 * 60 * 60 * 1000) {
    return day;
  }
  return `${month} ${num}`;
}
